<!-- 菜单：沙盒支付订单 /pages/dev/paymentSandboxOrderManage -->
<template>
  <div class="payment-sandbox-order-container">
    <el-card class="box-card">
      <div slot="header">
        <span>沙盒支付订单查询</span>
      </div>

      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="订单号">
          <el-input v-model="searchForm.orderId" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item label="商户号">
          <el-input v-model="searchForm.mchId" placeholder="请输入商户号" clearable />
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="待支付" value="0" />
            <el-option label="已支付" value="1" />
            <el-option label="已取消" value="2" />
            <el-option label="已退款" value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="日期范围">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" border v-loading="loading" style="width: 100%">
        <el-table-column prop="orderId" label="订单号" min-width="180" />
        <el-table-column prop="mchId" label="商户号" width="120" />
        <el-table-column prop="amount" label="金额(元)" width="100" align="right">
          <template slot-scope="scope">
            {{ (scope.row.amount / 100).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === '0'" type="warning">待支付</el-tag>
            <el-tag v-else-if="scope.row.status === '1'" type="success">已支付</el-tag>
            <el-tag v-else-if="scope.row.status === '2'" type="info">已取消</el-tag>
            <el-tag v-else-if="scope.row.status === '3'" type="danger">已退款</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="payTime" label="支付时间" width="160" />
        <el-table-column prop="createTime" label="创建时间" width="160" />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDetail(scope.row)">
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="page.current"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.size"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        style="margin-top: 20px; text-align: right"
      />
    </el-card>
  </div>
</template>

<script>
import { getPaymentSandboxOrderList } from '@/api/dev/paymentSandboxOrderApi'

export default {
  name: 'PaymentOrderManage',
  data() {
    return {
      loading: false,
      searchForm: {
        orderId: '',
        mchId: '',
        status: '',
        dateRange: []
      },
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const params = {
          page: this.page.current,
          row: this.page.size,
          orderId: this.searchForm.orderId,
          mchId: this.searchForm.mchId,
          status: this.searchForm.status,
          startDate: this.searchForm.dateRange ? this.searchForm.dateRange[0] : '',
          endDate: this.searchForm.dateRange ? this.searchForm.dateRange[1] : ''
        }
        const res = await getPaymentSandboxOrderList(params)
        this.tableData = res.data || []
        this.page.total = res.total || 0
      } catch (error) {
        this.$message.error(error.message || '查询失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.page.current = 1
      this.getList()
    },
    handleReset() {
      this.searchForm = {
        orderId: '',
        mchId: '',
        status: '',
        dateRange: []
      }
      this.handleSearch()
    },
    handleDetail(row) {
      this.$message.info('订单详情: ' + row.orderId)
    },
    handleSizeChange(val) {
      this.page.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.getList()
    }
  }
}
</script>

<style scoped>
.payment-sandbox-order-container {
  padding: 20px;
}

.search-form {
  margin-bottom: 20px;
}
</style>
